import React from "react";
import { motion } from "framer-motion";

function CardAnim({ des, img }) {
  const container = {
    rest: {
      transition: {
        when: "afterChildren",
      },
    },
    hover: {
      transition: {
        when: "beforeChildren",
        staggerChildren: 0.06,
      },
    },
  };
  const variants = {
    rest: {
      x: 0,
      y: 0,
      transition: { type: "spring", stiffness: 300, damping: 30 },
    },
    hover: (c) => ({
      x: c * 10,
      y: -c * 10,
      transition: {
        type: "spring",
        stiffness: 260,
        damping: 25,
      },
    }),
  };
  const items = [1, 2, 3];

  return (
    <motion.div
      className="relative w-full h-full cursor-pointer group"
      variants={container}
      initial={"rest"}
      whileHover={"hover"}
    >
      {items.map((item, index) => (
        <motion.div
          className=" absolute w-full h-full  top-0 left-0 z-10"
          key={index}
          custom={index}
          variants={variants}
        >
          <div
            className={`w-full h-full text-blue-3 ${
              item === 1
                ? "bg-primario"
                : item === 2
                ? "bg-blue-1"
                : "bg-blue-5"
            } overflow-hidden border-4 border-primario rounded-lg text-center`}
          >
            {index === items.length - 1 ? (
              <div className=" w-full h-full flex flex-col justify-end ">
                {/* <div className="absolute -top-[60px] -left-[60px] opacity-0 group-hover:opacity-100 duration-200 ease-in-out">
                  <CircularText/>
                </div> */}
                {/* <img className="w-full h-full object-cover" src={img} alt={des} /> */}
                <p className="p-4">{des}</p>
              </div>
            ) : (
              ""
            )}
            {/* <p>Comunicación oral y escrita profesional en inglés.</p> */}
          </div>
        </motion.div>
      ))}

      {/* <motion.li variants={item}> 1 </motion.li>
      <motion.li variants={item}> 1 </motion.li>
      <motion.li variants={item}> 1 </motion.li> */}
    </motion.div>
  );
}

export default CardAnim;
